var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef, useEffect, forwardRef, useState } from "react";
import { useMergeRefs } from "../../../common/useFallbackRef";
import { Placement } from "./../../index";
var Tooltip = forwardRef(function (_a, ref) {
    var id = _a.id, _b = _a.isVisible, isVisible = _b === void 0 ? false : _b, text = _a.text, referentRef = _a.referentRef, className = _a.className, style = _a.style, otherProps = __rest(_a, ["id", "isVisible", "text", "referentRef", "className", "style"]);
    var tooltipRef = useRef(null);
    var combinedRef = useMergeRefs([ref, tooltipRef]);
    var _c = useState(undefined), tooltipStyle = _c[0], setTooltipStyle = _c[1];
    var _d = useState(0), translateX = _d[0], setTranslateX = _d[1];
    var _e = useState(0), translateY = _e[0], setTranslateY = _e[1];
    var _f = useState("top"), placement = _f[0], setPlacement = _f[1];
    var _g = useState("center"), align = _g[0], setAlign = _g[1];
    useEffect(function () {
        var calculatePlacementAndAlign = function () {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            if (!isVisible) {
                setTooltipStyle(undefined);
                setTranslateX(0);
                setTranslateY(0);
                return;
            }
            var placement = new Placement(referentRef, tooltipRef);
            setPlacement(placement.getPlaceValue());
            setAlign(placement.getAlignValue());
            var x = ((_b = (_a = placement.getParentRect()) === null || _a === void 0 ? void 0 : _a.center) !== null && _b !== void 0 ? _b : 0) - ((_d = (_c = placement.getCurrentRect()) === null || _c === void 0 ? void 0 : _c.center) !== null && _d !== void 0 ? _d : 0);
            var limit = ((_f = (_e = placement.getCurrentRect()) === null || _e === void 0 ? void 0 : _e.width) !== null && _f !== void 0 ? _f : 0) * 0.5 - 8;
            if (x < -limit)
                x = -limit;
            if (x > limit)
                x = limit;
            var translates = placement.getTranslate(translateX, translateY);
            setTranslateX((_g = translates === null || translates === void 0 ? void 0 : translates.translateX) !== null && _g !== void 0 ? _g : 0);
            setTranslateY((_h = translates === null || translates === void 0 ? void 0 : translates.translateY) !== null && _h !== void 0 ? _h : 0);
            setTooltipStyle({
                "--arrow-x": "".concat(x.toFixed(2), "px"),
                transform: "translate(".concat(translates === null || translates === void 0 ? void 0 : translates.translateX, "px,").concat(translates === null || translates === void 0 ? void 0 : translates.translateY, "px)"),
            });
        };
        var handleResizeOrScroll = function () {
            calculatePlacementAndAlign();
        };
        calculatePlacementAndAlign();
        window.addEventListener("resize", handleResizeOrScroll);
        window.addEventListener("scroll", handleResizeOrScroll, true);
        return function () {
            window.removeEventListener("resize", handleResizeOrScroll);
            window.removeEventListener("scroll", handleResizeOrScroll, true);
        };
    }, [isVisible, referentRef === null || referentRef === void 0 ? void 0 : referentRef.current, translateX, translateY]);
    var tooltipClass = "fr-tooltip fr-placement";
    if (placement) {
        tooltipClass += " fr-placement--".concat(placement);
    }
    if (align) {
        tooltipClass += " fr-placement--".concat(align);
    }
    if (isVisible) {
        tooltipClass += " fr-tooltip--shown";
    }
    if (className) {
        tooltipClass += " ".concat(className);
    }
    return (React.createElement("span", __assign({}, otherProps, { ref: combinedRef, className: tooltipClass, id: id, role: "tooltip", "aria-hidden": !isVisible, style: __assign(__assign({}, style), tooltipStyle) }), text));
});
export default Tooltip;
